import React, { useEffect, useState, useCallback } from "react";
import api, { errMsg } from "../../core/api";
import { useApp } from "../../core/AppContext";
import { formatDate, todayIso, initials } from "../../core/format";
import Modal from "../../components/Modal";
import Select from "../../components/Select";
import Table from "../../components/Table";
import FormFields, { validateRequired } from "../../components/FormFields";
import ResponsiveList from "../../components/ResponsiveList";
import PrintReport from "../../components/PrintReport";
import { missionPrint } from "../../core/printConfigs";
// انتخاب چند کارمند
function EmployeePicker({ employees, value, onChange, error }) {
  const toggle = (id) =>
    onChange(
      value.includes(id) ? value.filter((x) => x !== id) : [...value, id],
    );
  return (
    <div className="field" style={{ gridColumn: "1 / -1" }}>
      <label>
        افراد ماموریت<span className="req">*</span>
      </label>
      <div className="check-list">
        {employees.map((e) => (
          <label
            key={e.id}
            className={`check-item ${value.includes(e.id) ? "on" : ""}`}
            style={{ margin: 0 }}
          >
            <input
              type="checkbox"
              checked={value.includes(e.id)}
              onChange={() => toggle(e.id)}
            />
            {e.firstName} {e.lastName}
          </label>
        ))}
      </div>
      {error && <small className="cm-err">{error}</small>}
    </div>
  );
}
function FinishModal({ item, onClose, onDone }) {
  const { toast } = useApp();
  const [text, setText] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const go = async () => {
    if (text.trim().length < 10) return setErr("گزارش ماموریت را بنویسید (حداقل ۱۰ کاراکتر)");
    setBusy(true);
    setErr("");
    try {
      await api.post(`/missions/${item.id}/finish`, { report: text.trim() });
      toast("گزارش ماموریت ثبت شد");
      onDone();
    } catch (e) {
      setErr(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <Modal
      title="پایان ماموریت"
      onClose={() => !busy && onClose()}
      footer={
        <>
          <button className="btn" onClick={go} disabled={busy}>
            {busy ? "در حال ثبت..." : "ثبت و پایان ماموریت"}
          </button>
          <button className="btn btn-ghost" onClick={onClose} disabled={busy}>
            انصراف
          </button>
        </>
      }
    >
      {err && <div className="alert err">{err}</div>}
      <b>{item.title}</b>
      <div className="hint" style={{ marginBottom: 10 }}>
        {formatDate(item.missionDate)} — {item.location}
      </div>
      <div className="field">
        <label>گزارش ماموریت<span className="req">*</span></label>
        <textarea
          rows={6}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="نتیجه و اقدامات انجام‌شده در ماموریت را بنویسید..."
        />
      </div>
    </Modal>
  );
}
export default function Missions() {
const { toast, confirm, user, meta } = useApp();
const canManage = ["admin", "manager"].includes(user.role);
const typeOpts = Object.entries(meta?.missionTypes || {}).map(([value, label]) => ({ value, label }));

  const [emps, setEmps] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // { row|null }
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [formErr, setFormErr] = useState("");
  const [saving, setSaving] = useState(false);
  const [finish, setFinish] = useState(null);   // ✅ این خط رو اضافه کن
const [printRow, setPrintRow] = useState(null);

  const fields = [
{ name: "title", label: "موضوع ماموریت", required: true },
{ name: "missionType", label: "نوع ماموریت", type: "select", options: typeOpts, required: true },
{ name: "missionDate", label: "از تاریخ", type: "date", required: true },
{ name: "toDate", label: "تا تاریخ", type: "date", required: true },
{ name: "location", label: "محل ماموریت", required: true, full: true },
    { name: "description", label: "شرح ماموریت", type: "textarea" },
    {
      name: "employeeIds",
      label: "افراد",
      type: "custom",
      full: true,
      render: ({ form, setForm }) => (
        <EmployeePicker
          employees={emps}
          value={form.employeeIds || []}
          onChange={(v) => setForm((f) => ({ ...f, employeeIds: v }))}
        />
      ),
    },
  ];

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [m, e] = await Promise.all([
        api.get("/missions"),
        api.get("/employees"),
      ]);
      setRows(m.data.items || []);
      setEmps(e.data.items || []);
    } catch (e) {
      toast(errMsg(e), "err");
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => {
    load();
  }, [load]);

  const openNew = () => {
    setForm({ employeeIds: [] });
    setErrors({});
    setFormErr("");
    setModal({ row: null });
  };
  const openEdit = (r) => {
    setForm({ ...r, employeeIds: r.employees.map((e) => e.id) });
    setErrors({});
    setFormErr("");
    setModal({ row: r });
  };

  const submit = async () => {
    const editing = !!modal.row;
    const errs = validateRequired(fields, form, { editing });
    setErrors(errs);
    if (Object.keys(errs).length) return;
    if (!form.employeeIds?.length)
      return setErrors({ employeeIds: "حداقل یک نفر را انتخاب کنید" });
    setSaving(true);
    setFormErr("");
    try {
    const body = { title: form.title, location: form.location, missionDate: form.missionDate, toDate: form.toDate,
  missionType: form.missionType, description: form.description || "", employeeIds: form.employeeIds };

      if (editing) await api.put(`/missions/${modal.row.id}`, body);
      else await api.post("/missions", body);
      toast(editing ? "تغییرات ذخیره شد" : "ماموریت ثبت شد");
      setModal(null);
      load();
    } catch (e) {
      setFormErr(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  const remove = async (r) => {
    if (!(await confirm("این ماموریت حذف شود؟"))) return;
    try {
      await api.delete(`/missions/${r.id}`);
      toast("حذف شد");
      load();
    } catch (e) {
      toast(errMsg(e), "err");
    }
  };

  return (
    <>
      <div className="page-head">
        <div>
          <h2>ماموریت‌ها</h2>
          <p>صدور ماموریت برای یک یا چند نفر</p>
        </div>
        <button className="btn" onClick={openNew}>
          <i className="fa-solid fa-plus" /> صدور ماموریت
        </button>
      </div>

      <ResponsiveList
        loading={loading}
        rows={rows}
        empty="ماموریتی ثبت نشده است"
        columns={[
          {
            key: "missionDate",
            label: "تاریخ",
            render: (r) => formatDate(r.missionDate),
          },
          {
            key: "title",
            label: "عنوان ماموریت",
            render: (r) => <b>{r.title}</b>,
          },
          { key: "location", label: "محل ماموریت" },
          { key: "missionDate", label: "بازه", render: (r) => `${formatDate(r.missionDate)} تا ${formatDate(r.toDate || r.missionDate)}` },
{ key: "missionType", label: "نوع", render: (r) => r.missionTypeLabel || "—" },
          {
            key: "employees",
            label: "اعضا",
            render: (r) => (
              <div className="chips">
                {r.employees.map((e) => (
                <span key={e.id} className={`badge ${e.status === "done" ? "ok" : e.overdue ? "bad" : e.status === "in_progress" ? "warn" : "wait"}`}
  title={e.report || ""}>
  {e.name}: {e.status === "done" ? "انجام شد" : e.overdue ? "انجام نشد (گذشته)" : e.status === "in_progress" ? "در حال انجام" : "شروع نشده"}
</span>
                ))}
              </div>
            ),
          },
        ]}
        mobileTitle={(r) => r.title}
        mobileBadge={(r) => (
          <span className="mc-date">{formatDate(r.missionDate)}</span>
        )}
        mobileMeta={(r) => [
          { icon: "fa-solid fa-location-dot", label: "محل", value: r.location },
          {
            icon: "fa-solid fa-users",
            full: true,
            value: (
              <div className="chips">
                {r.employees.map((e) => (
                  <span key={e.id} className="chip">
                    {e.name}
                  </span>
                ))}
              </div>
            ),
          },
          ...(r.description
            ? [
                {
                  icon: "fa-regular fa-note-sticky",
                  full: true,
                  value: r.description,
                },
              ]
            : []),
        ]}
        actions={(r) => (
          <>
          <button className="icon-btn" title="چاپ گزارش" onClick={() => setPrintRow(r)}><i className="fa-solid fa-print" /></button>

            {r.myStatus === "pending" && <button className="btn btn-sm btn-ghost" onClick={async () => {
      try { await api.post(`/missions/${r.id}/start`, {}); toast("ماموریت شروع شد"); load(); } catch (e) { toast(errMsg(e), "err"); } }}>شروع</button>}
    {r.myStatus === "in_progress" && <button className="btn btn-sm" onClick={() => setFinish(r)}><i className="fa-solid fa-check" /> پایان ماموریت</button>}
    {canManage && (<>
            <button
              className="icon-btn"
              title="ویرایش"
              onClick={() => openEdit(r)}
            >
              <i className="fa-solid fa-pen" />
            </button>
            <button
              className="icon-btn danger"
              title="حذف"
              onClick={() => remove(r)}
            >
              <i className="fa-solid fa-trash" />
            </button>
             </>)}
          </>
        )}
      />
      {modal && (
        <Modal
          title={modal.row ? "ویرایش ماموریت" : "صدور ماموریت"}
          onClose={() => !saving && setModal(null)}
          footer={
            <>
              <button className="btn" onClick={submit} disabled={saving}>
                {saving
                  ? "در حال ذخیره..."
                  : modal.row
                    ? "ذخیره تغییرات"
                    : "ثبت"}
              </button>
              <button
                className="btn btn-ghost"
                onClick={() => setModal(null)}
                disabled={saving}
              >
                انصراف
              </button>
            </>
          }
        >
          {formErr && <div className="alert err">{formErr}</div>}
          <FormFields
            fields={fields}
            form={form}
            setForm={setForm}
            errors={errors}
          />
        </Modal>
      )}
      {finish && (                                   
        <FinishModal
          item={finish}
          onClose={() => setFinish(null)}
          onDone={() => { setFinish(null); load(); }}
        />
      )}
      {printRow && <PrintReport {...missionPrint(printRow)} onClose={() => setPrintRow(null)} />}

    </>
  );
}
